exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".carousel-wrapper[data-v-5b8c1ec9]{position:relative;margin-bottom:5%;background-color:#474747;padding:2% 5%}.check-all-btn[data-v-5b8c1ec9]{position:absolute;bottom:-20px;right:-40px}.h-100p[data-v-5b8c1ec9]{height:100%}.customer-card-wrapper[data-v-5b8c1ec9]{margin-bottom:100px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5b8c1ec9","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/videoconversation/VideoConversation.vue
// module id = 1038
// module chunks = 0